export namespace GasColor {

  /** @deprecated используйте из стилей цвета, делать через классы, берем IconColorClass */
  export enum Color {
    Brand = '#4192D9',
    Error = '#D94641',
    Success = '#41D994',
    SuccessDark = '#2F9E6C',
    Warning = '#D99441',
    White = '#FFFFFF',
    Light = '#BEBEBE',
    Disabled = '#DDDBDA',
    Black = '#1F1F1F',
    DarkBrown = '#6C6A67',
  }

  export enum Name {
    Default = 'default',
    Brand = 'brand',
    Error = 'error',
  }

  export enum IconColorClass {
    Brand = 'icon-brand',
    Black = 'icon-black',
    Warning = 'icon-warning',
    Success = 'icon-success',
    White = 'icon-white',
    Error = 'icon-error',
    Dark = 'icon-dark',
    Medium = 'icon-medium',
    Disabled = 'icon-disabled',
    WarningMedium = 'icon-warning',
    GreenEmerald = 'icon-green-emerald',
    BlueAzure = 'icon-blue-azure',
    LineDark = 'icon-line-dark',
    Cornflower = 'icon-cornflower',
    FernCraiola = 'icon-fern-craiola',
    MediumPurple = 'icon-medium-purple',
  }
}
